import { useEffect, useRef, EffectCallback, DependencyList } from "react";

const mountedComponents = new WeakSet<object>();

/**
 * Comme useEffect, mais ignore le premier rendu.
 * Fonctionne même en mode StrictMode (dev).
 */
export function useDidUpdateEffect(effect: EffectCallback, deps: DependencyList) {
  const instance = useRef<object>({});
  const isFirstRender = !mountedComponents.has(instance.current);

  useEffect(() => {
    // Si c'est le premier rendu (y compris après un remount de StrictMode)
    if (isFirstRender) {
      mountedComponents.add(instance.current);
      return;
    }

    // Sinon, exécuter l'effet
    return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
